import angular from 'angular';
import constants from 'app/constants';
import {
  riskDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-risk-type-confirm-dialog.controller';
import template from './delete-risk-type-confirm-dialog.html';

class dialogService {
  getOptions($event, {
    riskType,
    assetType
  }) {
    return {
      controller,
      controllerAs: 'deleteRiskTypeConfirmDialogVM',
      locals: {
        riskType,
        assetType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.risk.deleteRiskTypeConfirmDialog', [
  alerts,
  riskDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteRiskTypeConfirmDialog', dialogService)
  .name;
